const ssn = {
    ssn : {
        value: "",
        dbqName: "form1[0].#subform[0].VetInfoSF[0].SSN[0]"
     },
     examDate: {
        value: "",
        dbqName: "form1[0].#subform[0].VetInfoSF[0].DateofExam[0]"
    },
     docName: {
         value: "",
         dbqName: "form1[0].#subform[0].SectionXVI-ExaminersCertSign[0].SectionXVI-ExaminersCertSign[0].TextField8[1]"
     },
     docArea: {
        value: "",
        dbqName: "form1[0].#subform[0].SectionXVI-ExaminersCertSign[0].SectionXVI-ExaminersCertSign[0].TextField8[6]"
    },     
     docDate: {
        value : "",
        dbqName: "form1[0].#subform[0].SectionXVI-ExaminersCertSign[0].SectionXVI-ExaminersCertSign[0].TextField8[7]"
    },
     docNpi: {
         value : "",
         dbqName: "form1[0].#subform[0].SectionXVI-ExaminersCertSign[0].SectionXVI-ExaminersCertSign[0].TextField8[3]"
     },
     docPhone: {
        value : "",
        dbqName: "form1[0].#subform[0].SectionXVI-ExaminersCertSign[0].SectionXVI-ExaminersCertSign[0].TextField8[2]"
    },
    docLicenseNo: {
        value : "",
        dbqName: "form1[0].#subform[0].SectionXVI-ExaminersCertSign[0].SectionXVI-ExaminersCertSign[0].TextField8[4]"
    },
    docAddress: {
        value : "",
        dbqName: "form1[0].#subform[0].SectionXVI-ExaminersCertSign[0].SectionXVI-ExaminersCertSign[0].TextField8[5]"
    },
    diagnosisDate : [
        {
            type: "checkbox",
            dbqName: "form1[0].#subform[0].SectionI-DXSF[0].MI[0].CheckBox36[0]",
            dateDbqName: "form1[0].#subform[0].SectionI-DXSF[0].MI[0].TextField4[0]",
        },
        {
            type: "checkbox",
            dbqName: "form1[0].#subform[0].SectionI-DXSF[0].AtheroscleroticCardiovasc[0].CheckBox36[1]",
            dateDbqName: "form1[0].#subform[0].SectionI-DXSF[0].AtheroscleroticCardiovasc[0].TextField4[1]",
        },
        {
            type: "checkbox",
            dbqName: "form1[0].#subform[0].SectionI-DXSF[0].UnstableAngina[0].CheckBox36[2]",
            dateDbqName: "form1[0].#subform[0].SectionI-DXSF[0].UnstableAngina[0].TextField4[2]",
        },
        {
            type: "checkbox",
            dbqName: "form1[0].#subform[0].SectionI-DXSF[0].StableAngina[0].CheckBox36[3]",
            dateDbqName: "form1[0].#subform[0].SectionI-DXSF[0].StableAngina[0].TextField4[3]",
        },
        {
            type: "checkbox",
            dbqName: "form1[0].#subform[0].SectionI-DXSF[0].Arteriosclerotic-CAD[0].CheckBox36[4]",
            dateDbqName: "form1[0].#subform[0].SectionI-DXSF[0].Arteriosclerotic-CAD[0].TextField4[4]",
        },
        {
            type: "checkbox",
            dbqName: "form1[0].#subform[0].SectionI-DXSF[0].CoronarySpasm[0].CheckBox36[5]",
            dateDbqName: "form1[0].#subform[0].SectionI-DXSF[0].CoronarySpasm[0].TextField4[5]",
        },
        {
            type: "checkbox",
            dbqName: "form1[0].#subform[0].SectionI-DXSF[0].#area[6].CheckBox36[6]",
            dateDbqName: "form1[0].#subform[0].SectionI-DXSF[0].#area[6].TextField4[6]",
        },
        {
            type: "checkbox",
            dbqName: "form1[0].#subform[0].SectionI-DXSF[0].#area[7].CheckBox36[7]",
            dateDbqName: "form1[0].#subform[0].SectionI-DXSF[0].#area[7].TextField4[7]",
        },
        {
            type: "checkbox",
            dbqName: "form1[0].#subform[0].SectionI-DXSF[0].#area[8].CheckBox36[8]",
            dateDbqName: "form1[0].#subform[0].SectionI-DXSF[0].#area[8].TextField4[8]",
        },
        {
            type: "checkbox",
            dbqName: "form1[0].#subform[0].SectionI-DXSF[0].#area[9].CheckBox36[9]",
            dateDbqName: "form1[0].#subform[0].SectionI-DXSF[0].#area[9].TextField4[9]",
        },
        {
            type: "checkbox",
            dbqName: "form1[0].#subform[0].SectionI-DXSF[0].#area[10].CheckBox36[10]",
            dateDbqName: "form1[0].#subform[0].SectionI-DXSF[0].#area[10].TextField4[10]",
        },
        {
            type: "checkbox",
            dbqName: "form1[0].#subform[0].SectionI-DXSF[0].#area[11].CheckBox36[11]",
            dateDbqName: "form1[0].#subform[0].SectionI-DXSF[0].#area[11].TextField4[11]",
        },
        {
            type: "checkbox",
            dbqName: "form1[0].#subform[0].SectionI-DXSF[0].#area[12].CheckBox36[12]",
            dateDbqName: "form1[0].#subform[0].SectionI-DXSF[0].#area[12].TextField4[12]",
        },
        {
            type: "checkbox",
            dbqName: "form1[0].#subform[0].SectionI-DXSF[0].#area[13].CheckBox36[13]",
            dateDbqName: "form1[0].#subform[0].SectionI-DXSF[0].#area[13].TextField4[13]",
        },
        {
            type: "checkbox",
            dbqName: "form1[0].#subform[0].SectionI-DXSF[0].#area[14].CheckBox36[14]",
            dateDbqName: "form1[0].#subform[0].SectionI-DXSF[0].#area[14].TextField4[14]",
        },
        {
            type: "checkbox",
            dbqName: "form1[0].#subform[0].SectionI-DXSF[0].#area[15].CheckBox36[15]",
            dateDbqName: "form1[0].#subform[0].SectionI-DXSF[0].#area[15].TextField4[15]",
        },
        {
            type: "checkbox",
            dbqName: "form1[0].#subform[0].SectionI-DXSF[0].#area[16].CheckBox36[16]",
            dateDbqName: "form1[0].#subform[0].SectionI-DXSF[0].#area[16].TextField4[16]",
        },
        {
            type: "checkbox",
            dbqName: "form1[0].#subform[0].SectionI-DXSF[0].#area[17].CheckBox36[17]",
            dateDbqName: "form1[0].#subform[0].SectionI-DXSF[0].#area[17].TextField4[17]",
        },
        {
            type: "checkbox",
            dbqName: "form1[0].#subform[0].SectionI-DXSF[0].#area[18].CheckBox36[18]",
            dateDbqName: "form1[0].#subform[0].SectionI-DXSF[0].#area[18].TextField4[18]",
        },
        {
            type: "checkbox",
            dbqName: "form1[0].#subform[0].SectionI-DXSF[0].#area[19].CheckBox36[19]",
            dateDbqName: "form1[0].#subform[0].SectionI-DXSF[0].#area[19].TextField4[19]",
        },
        {
            type: "checkbox",
            dbqName: "form1[0].#subform[0].SectionI-DXSF[0].#area[20].CheckBox36[20]",
            dateDbqName: "form1[0].#subform[0].SectionI-DXSF[0].#area[20].TextField4[20]",
        },
        {
            type: "checkbox",
            dbqName: "form1[0].#subform[0].SectionI-DXSF[0].#area[21].CheckBox36[21]",
            dateDbqName: "form1[0].#subform[0].SectionI-DXSF[0].#area[21].TextField4[21]",
        },
        {
            type: "checkbox",
            dbqName: "form1[0].#subform[0].SectionI-DXSF[0].#area[22].CheckBox36[22]",
            dateDbqName: "form1[0].#subform[0].SectionI-DXSF[0].#area[22].TextField4[22]",
        },
        {
            type: "checkbox",
            dbqName: "form1[0].#subform[0].SectionI-DXSF[0].#area[23].CheckBox36[23]",
            dateDbqName: "form1[0].#subform[0].SectionI-DXSF[0].#area[23].TextField4[23]",
        },
        {
            type: "checkbox",
            dbqName: "form1[0].#subform[0].SectionI-DXSF[0].#area[24].CheckBox36[24]",
            dateDbqName: "form1[0].#subform[0].SectionI-DXSF[0].#area[24].TextField4[24]",
        },
        {
            type: "checkbox",
            dbqName: "form1[0].#subform[0].SectionI-DXSF[0].#area[25].CheckBox36[25]",
            dateDbqName: "form1[0].#subform[0].SectionI-DXSF[0].#area[25].TextField4[25]",
        }, 
        {
            type: "checkbox",
            dbqName: "form1[0].#subform[0].SectionI-DXSF[0].#area[26].CheckBox36[26]",
            dateDbqName: "form1[0].#subform[0].SectionI-DXSF[0].#area[26].TextField4[26]",
        },
              
        {
            type: "text",
            dbqName: "form1[0].#subform[0].SectionI-DXSF[0].#area[26].#area[27].TextField6[0]",
            dateDbqName: "form1[0].#subform[0].SectionI-DXSF[0].#area[26].#area[27].TextField4[28]",
        },
        {
            type: "text",
            dbqName: "form1[0].#subform[0].SectionI-DXSF[0].#area[26].#area[27].TextField6[1]",
            dateDbqName: "form1[0].#subform[0].SectionI-DXSF[0].#area[26].#area[27].TextField4[27]",
        },    
        {
            type: "text",
            dbqName: "form1[0].#subform[0].SectionI-DXSF[0].#area[26].#area[27].TextField6[2]",
            dateDbqName: "form1[0].#subform[0].SectionI-DXSF[0].#area[26].#area[27].TextField4[29]",
        },     
    ]

}

export default ssn ;